import ZoomControls from "./ZoomControls";

export default ZoomControls;
